import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import authAtom, { isAuthInitializedAtom } from '../features/auth/authAtom';

// ルート ('/') 直アクセス時: 認証初期化完了まで待機し、ログイン状態で振り分け
const HomeRedirect = (): ReactElement => {
  const session = useAtomValue(authAtom); // undefined | null | session
  const initialized = useAtomValue(isAuthInitializedAtom);

  if (!initialized) {
    return <Spin />; // 初期化待ち
  }
  const target = session ? '/recordings' : '/login';
  return <Navigate to={target} replace />;
};

export default HomeRedirect;
